import classNames from "classnames";

export const videosWrapper = classNames([
  /* Tablet */
  "tablet:p-14",
  /* All */
  "p-8",
  "bg-[#263237]",
]);

export const videosContainer = classNames([
  "w-full",
  "max-w-[900px]",
  "flex",
  "flex-wrap",
  "items-center",
  "justify-evenly",
  "mt-16",
  "ml-auto",
  "mr-auto",
]);

export const iframeContainer = classNames([
  "w-full",
  "max-w-[430px]",
  "min-h-[230px]",
]);

export const iframe = classNames([
  "w-full",
  "h-[250px]",
  "mb-5",
  "border",
  "border-1",
  "border-white",
]);

export const button = classNames([
  // All
  "text-xl",
  "font-semibold",
  "mb-6",
  "pl-3",
  "pr-3",
  "pt-3",
  "pb-3",
  "rounded-xl",
  "w-56",
  "mt-10",
  "bg-primary",
  "text-white",
]);

export const fallbackContainer = classNames(["relative", "w-full"]);
export const fallbackImage = classNames(["relative", "w-full"]);
export const fallbackIcon = classNames([
  "absolute",
  "top-1/2",
  "left-1/2",
  "transform",
  "-translate-x-1/2",
  "-translate-y-1/2",
]);
